export default (code) => code.replace(/fill=".*?"/g, 'fill="#999"');
